import { UserDetailsViewModel } from "../../configuration/api/apiSchema";
import { updateObject } from "../../helpers/updateObject";
import { LOGOUT, REFRESH_TOKEN, SIGN_IN_USER, SEND_SIGN_UP_USER_OTP, SIGN_UP_USER, CHECK_DUPLICATE_EMAIL, GET_USER_DETAILS, UPDATE_USER_DETAILS, UPDATE_USER_AVATAR, GET_CURRENT_USER_DETAILS } from "./actions";

export type UserState = {
    authData?: AuthData;
    isAuthorized: boolean;
    refreshTokenTimeout?: any;
    isLoading: boolean;
    isDetailsUpdated: boolean;
    isIncorrectCredentials: boolean;
    errorType?: SignInErrorType,
    isError: boolean;
    isSignUpSuccessfull: boolean;
    isOtpConfirmed: boolean;
    isSignupLoading: boolean;
    isDuplicatedEmailError: boolean;
    isDuplicatedEmailChecked: boolean;
    userDetails?: UserDetailsViewModel;
    currentUserDetails?: UserDetailsViewModel;
    isAvatarUpdated: boolean;
}

export type AuthData = {
    fullName: string;
    role: string;
    access_token: string;
    expires_in: number;
    refresh_token: string;
    status: string;
}

export enum SignInErrorType {
    incorrectCredentials = 1,
    unknown = 2
}

const initialState = {
    id: undefined,
    authData: undefined,
    isAuthorized: false,
    refreshTokenTimeout: undefined,
    isLoading: false,
    isIncorrectCredentials: false,
    isError: false,
    isSignUpSuccessfull: false,
    isOtpConfirmed: false,
    isSignupLoading: false,
    isDuplicatedEmailError: false,
    isDuplicatedEmailChecked: false,
    userDetails: undefined,
    isDetailsUpdated: false,
    isAvatarUpdated: false,
    currentUserDetails: undefined,
};

export const reducer = (state: UserState = initialState, action: any) => {
    switch (action.type) {
        // case THROW_ERROR:
        //     return updateObject(state, { isLoadingTable: false, isLoading: false, isError: true });
        case SIGN_IN_USER.REQUEST:
            return updateObject(state, { authData: undefined, isAuthorized: false, refreshTokenTimeout: undefined, isLoading: true, errorType: undefined, isError: false });
        case SIGN_IN_USER.SUCCESS:
            return updateObject(state, { authData: action.authData, isAuthorized: true, refreshTokenTimeout: action.refreshTokenTimeout, isLoading: false });
        case SIGN_IN_USER.ERROR:
            return updateObject(state, { authData: undefined, isAuthorized: false, refreshTokenTimeout: undefined, isLoading: false, errorType: action.errorType, isError: true });

        case REFRESH_TOKEN.REQUEST:
            return updateObject(state, { authData: undefined, isAuthorized: false, refreshTokenTimeout: undefined });
        case REFRESH_TOKEN.SUCCESS:
            return updateObject(state, { authData: action.authData, isAuthorized: true, refreshTokenTimeout: action.refreshTokenTimeout });

        case SEND_SIGN_UP_USER_OTP.REQUEST:
            return updateObject(state, { isLoading: true, isError: false, isOtpConfirmed: false });
        case SEND_SIGN_UP_USER_OTP.SUCCESS:
            return updateObject(state, { isLoading: false, isOtpConfirmed: true });

        case SIGN_UP_USER.REQUEST:
            return updateObject(state, { isLoading: true, errorType: undefined, isError: false, isSignUpSuccessfull: false, isSignupLoading: true });
        case SIGN_UP_USER.SUCCESS:
            return updateObject(state, { isLoading: false, isSignUpSuccessfull: true, isSignupLoading: false });
        case SIGN_UP_USER.ERROR:
            return updateObject(state, { isLoading: false, errorType: action.errorType, isError: true, isSignUpSuccessfull: false, isSignupLoading: false });

        case CHECK_DUPLICATE_EMAIL.REQUEST:
            return updateObject(state, { isLoading: true, isDuplicatedEmailError: false, isDuplicatedEmailChecked: false });
        case CHECK_DUPLICATE_EMAIL.SUCCESS:
            return updateObject(state, { isLoading: false, isDuplicatedEmailError: action.isDuplicatedEmailError, isDuplicatedEmailChecked: true });

        case GET_USER_DETAILS.REQUEST:
            return updateObject(state,
                {
                    isLoading: true,
                    userDetails: undefined
                });
        case GET_USER_DETAILS.SUCCESS:
            return updateObject(state,
                {
                    isLoading: false,
                    userDetails: action.userDetails
                });

        case GET_CURRENT_USER_DETAILS.REQUEST:
            return updateObject(state,
                {
                    isLoading: true,
                    currentUserDetails: undefined
                });
        case GET_CURRENT_USER_DETAILS.SUCCESS:
            return updateObject(state,
                {
                    isLoading: false,
                    currentUserDetails: action.currentUserDetails
                });

        case UPDATE_USER_DETAILS.REQUEST:
            return updateObject(state, { isLoading: true, isDetailsUpdated: false });
        case UPDATE_USER_DETAILS.SUCCESS:
            return updateObject(state, { isLoading: false, isDetailsUpdated: true });
        case UPDATE_USER_AVATAR.REQUEST:
            return updateObject(state, { isLoading: true, isAvatarUpdated: false });
        case UPDATE_USER_AVATAR.SUCCESS:
            return updateObject(state, { isLoading: false, isAvatarUpdated: true });

        case LOGOUT:
            return updateObject(state, { authData: undefined, isAuthorized: false, refreshTokenTimeout: undefined, isLoading: false, errorType: undefined, isError: false });

        default:
            return state;
    }
};